import { render, staticRenderFns } from "./MemberPackage.vue?vue&type=template&id=5f856e54&scoped=true&"
import script from "./MemberPackage.vue?vue&type=script&lang=js&"
export * from "./MemberPackage.vue?vue&type=script&lang=js&"
import style0 from "./MemberPackage.vue?vue&type=style&index=0&id=5f856e54&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f856e54",
  null
  
)

export default component.exports